import type { MenuOptions } from '@blocksuite/hive-components/context-menu';
import { type DatabaseBlockModel } from '@blocksuite/hive-model';
import { ConfigExtensionFactory } from '@blocksuite/std';

export interface DatabaseOptionsConfig {
  configure: (model: DatabaseBlockModel, options: MenuOptions) => MenuOptions;
}

export const DatabaseConfigExtension =
  ConfigExtensionFactory<DatabaseOptionsConfig>('hive:database');
